import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import * as OutcomesView from '~/web-frontend-components/line/Outcomes';
import { FavoriteStar } from '~/web-frontend-components/std/UI';
import { LOCK_STATE, STATE } from '~/web-frontend-core/api/const/base';
import { AdditionalTableOutcomes } from './additional/TableOutcomes';
import { sendLogKafka, Events } from '~/web-frontend-components/helpers/kafka';
import { withRouter } from 'react-router';
import { sportsIds } from '~/web-frontend-components/line/matches.mobile/list/sport/championship/Match';
const getMatchIdFromSlug = (slug) => {
    var _a;
    return (_a = (slug || '').match(/\d+/)) === null || _a === void 0 ? void 0 : _a[0];
};
const useStyles = createUseStyles({
    matchTitle: {
        display: 'flex',
        position: 'relative',
    },
    translations: {
        // position: 'absolute',
        right: '0',
        top: '0',
        display: 'block',
        // paddingLeft: '3px',
        backgroundColor: '#f9f9f9',
    },
    structureScoreContainer: {
        display: 'flex',
        marginRight: '4px',
    },
    structureScoreItem: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        margin: '4px 4px'
    },
    structureScoreItemBlock: {
        display: 'flex',
        justifyContent: 'center',
        color: '#747474'
    },
    structureScoreItemHeader: {
        display: 'flex',
        justifyContent: 'center',
        color: '#9898af'
    }
}, { name: 'Match' });
const sportsInfographic = {
    26: 'Soccer',
    27: 'IceHockey',
    28: 'Basketball',
    33: 'Tennis',
    41: 'Volleyball',
    134: 'TableTennis',
    235: 'Badminton',
    337: 'BeachVolleyball',
    635: 'ShortHockey',
    32: 'Handball',
    177: 'Futsal',
};
export const Match = withRouter((props) => {
    var _a, _b, _c, _d, _e, _f;
    //#region fold
    const subscriptionID = Number(props.matchID);
    const [isFolded, fold] = useState(!props.handlers.isUnfoldedMatch(props.matchID));
    const isIrm = props === null || props === void 0 ? void 0 : props.isIrm;
    const toggleMatch = () => {
        props.handlers.foldMatch(props.matchID, !isFolded);
        fold(!props.handlers.isUnfoldedMatch(props.matchID));
    };
    const openMatch = (matchID) => {
        props.handlers.foldMatch(matchID, true);
        fold(true);
        props.handlers.foldMatch(matchID, false);
        fold(false);
    };
    useEffect(() => {
        var _a, _b;
        // reinit additional table outcomes
        if (getMatchIdFromSlug((_b = (_a = props === null || props === void 0 ? void 0 : props.match) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.games) === String(props.matchID)) {
            openMatch(props.matchID);
        }
    }, [(_b = (_a = props === null || props === void 0 ? void 0 : props.match) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.games, props.matchID]);
    const subscribeOutcomes = () => props.outcomes.listenWS(subscriptionID);
    const unsubscribeOutcomes = () => props.outcomes.stopListenWS(subscriptionID);
    useEffect(() => {
        fold(!props.handlers.isUnfoldedMatch(props.matchID));
    }, [props.handlers.isUnfoldedMatch(props.matchID)]);
    useEffect(() => {
        isFolded ? unsubscribeOutcomes() : subscribeOutcomes();
    }, [isFolded]);
    //#endregion
    //#region favorite
    const [isFavorite, favorite] = useState(props.handlers.isFavoriteMatch(props.matchID));
    useEffect(() => {
        favorite(props.handlers.isFavoriteMatch(props.matchID));
    }, [props.handlers.isFavoriteMatch(props.matchID)]);
    const favoriteMatch = useCallback(() => {
        if (!isFavorite) {
            sendLogKafka(Events.favoUrites, { eventId: props.matchID });
        }
        props.handlers.favoriteMatch(props.matchID, !isFavorite);
        favorite(props.handlers.isFavoriteMatch(props.matchID));
    }, [props.matchID, isFavorite]);
    //#endregion
    const onVideoClick = useCallback(() => {
        props.handlers.onVideoClick({
            id: Number(props.matchID),
            stats: props.matchData.hasMatchInfo,
            hasInfographics: props.matchData.hasInfographics,
            sid: Number(props.sportID),
            c1: props.matchData.team1,
            c2: props.matchData.team2,
            score: props.matchData.score,
            video_type: props.matchData.video || []
        });
    }, [props.matchID, props.matchData.hasMatchInfo]);
    const onInfographicsClick = () => {
        props.handlers.onInfographicsClick({
            stats: props.matchData.hasMatchInfo,
            hasInfographics: props.matchData.hasInfographics,
            score: props.matchData.score,
            sid: Number(props.sportID),
            id: Number(props.matchID),
            c1: props.matchData.team1,
            c2: props.matchData.team2,
        });
        sendLogKafka(Events.matchCenterViewed, { eventId: props === null || props === void 0 ? void 0 : props.matchID });
    };
    const isDisabled = props.matchData.bl === LOCK_STATE.BLOCKED;
    const isCoefChoosen = (betID, oddID) => props.handlers.isCoefChoosen(props.matchID, betID, oddID);
    const onCoefChoose = (oddID) => {
        props.handlers.onCoefChoose(oddID, props.matchID);
    };
    const classes = useStyles();
    const isSingleMatch = props.match.params.games;
    // const structureScore = props.matchData?.sScore?.sScoreData?.scs.map((item, i) => {
    //    return (
    //       <div className={classes.structureScoreItem}>
    //          {i > 0 ? <div className={classes.structureScoreItemHeader}>{item?.d}</div> : ''}
    //          <div style={i === 0 ? {color: '#131313', fontWeight: '500'} : {}} className={classes.structureScoreItemBlock}>{item?.scv?.cur?.t1}</div>
    //          <div style={i === 0 ? {color: '#131313', fontWeight: '500'} : {}} className={classes.structureScoreItemBlock}>{item?.scv?.cur?.t2}</div>
    //       </div>
    //    )
    // })
    const debuggingMode = localStorage.getItem('debug_mode');
    const { um } = ((_d = (_c = props.matchData) === null || _c === void 0 ? void 0 : _c.sScore) === null || _d === void 0 ? void 0 : _d.sScoreData) || {};
    return <Fragment>
      <tr className="g-tr">
         <td className="g-d-td">
            {!isSingleMatch || (!um || (um == 2 && !debuggingMode)) || !(sportsIds === null || sportsIds === void 0 ? void 0 : sportsIds[props.sportID]) || isIrm
            ? <div className={classes.matchTitle}>
                  <div>
                     <FavoriteStar isFavorite={isFavorite} onClick={favoriteMatch}/>
                  </div>
                  <OutcomesView.Description description={props.matchData} url={props.url} inline={props.inlineDescription} matchId={props.matchID} displayGamesNumber={props.displayGamesNumber} deltaTimeMs={props.deltaTimeMs}/>
                  <div className={classes.structureScoreContainer}>
                     {/* {structureScore} */}
                  </div>
                  <div className={classes.translations}>
                     <div className="translations">
                        <TV data={props.matchData.tv}/>
                        <VideoChannels isVideoPlaying={props.handlers.isVideoPlaying(props.matchID)} video={props.matchData.video} onClick={onVideoClick}/>
                        <Infographics hasMatchInfo={props.matchData.hasMatchInfo === STATE.ENABLED} hasInfographics={props.matchData.hasInfographics === STATE.ENABLED} sportId={props.sportID} onClick={onInfographicsClick}/>
                     </div>
                  </div>
               </div>
            :
                <div style={{ textAlign: 'center' }}>{(_f = (_e = props.matchData) === null || _e === void 0 ? void 0 : _e.mainLineDescription) === null || _f === void 0 ? void 0 : _f.txt}</div>}
         </td>
         <OutcomesView.HeadTable.MainLine getCoef={(betID) => props.matchData.odds[betID]} mainLine={props.matchData.mainLine || []} disabled={isDisabled} highlightChanges={props.highlightChanges} isCoefChoosen={isCoefChoosen} onCoefChoose={onCoefChoose} className="g-tr"/>

         <td className="g-t-a-td">
            {props.matchData.oddsCnt &&
            <Toggle isFolded={isFolded} count={props.matchData.oddsCnt[props.width]} onClick={toggleMatch}/>}
         </td>
      </tr>

      {!isFolded && props.matchData.oddsCnt && <AdditionalTableOutcomes {...props} isCoefChoosen={isCoefChoosen} onCoefChoose={onCoefChoose}/>}
   </Fragment>;
});
const Toggle = React.memo((props) => {
    if (props.count === 0) {
        return null;
    }
    return <span className="g-t-a" onClick={props.onClick}>
      {`${props.isFolded ? '+' : '-'}${props.count}`}
   </span>;
});
const TV = React.memo((props) => {
    if (!props.data) {
        return null;
    }
    return <div className="g-tv fl_r">
      <span className="f-s-ico-tv"/>
      <div className="channels">
         <span className="channel"> {props.data} </span>
      </div>
   </div>;
});
const Infographics = React.memo((props) => {
    if ((props.hasInfographics && sportsInfographic[props === null || props === void 0 ? void 0 : props.sportId]) || props.hasMatchInfo) {
        return <div className="g-tv fl_r">
         <span className="f-s-ico-infographics" onClick={props.onClick}/>
      </div>;
    }
    return null;
});
const VideoChannels = React.memo((props) => {
    if (!props.video) {
        return null;
    }
    return <Fragment>{props.video.map((linkType) => <div key={`${linkType}`} className="g-tv fl_r">
            <span className={`item-ico-video${props.isVideoPlaying ? ' item-ico-video-playing' : ''} item-ico-video-type-${linkType}`} onClick={props.onClick}/>
         </div>)}</Fragment>;
});



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/matches/list/sport/championship/Match.jsx